import { useState } from "react";
import classes from "./ColumnsPersonalizer.module.css";
import { ReactComponent as DownArrow } from "../../../images/icons/table/down-arrow.svg";
import MultiLanTxt from "../../UI/MultiLanTxt/MultiLanTxt";

const ColumnsPersonalizer = ({ tableInfos, setTableInfos, changeShownColumnHandler, actionStatus }) => {
  const [dragId, setDragId] = useState();

  const changeOrderHandler = (e, data, type) => {
    if (actionStatus !== "editing" && actionStatus !== "adding") {
      e.stopPropagation();
      if (type === "increase" && data.order === tableInfos.length) {
        return;
      } else if (type === "decrease" && data.order === 1) {
        return;
      } else {
        setTableInfos((ps) => {
          let newTableInfos = [...ps];
          let targetedIndex = newTableInfos.findIndex((inf) => inf.id === data.id);
          let influencedIndex =
            type === "decrease"
              ? newTableInfos.findIndex((inf) => inf.order === data.order - 1)
              : type === "increase"
                ? newTableInfos.findIndex((which) => which.order === data.order + 1)
                : null;
          let newTargetedInf = { ...ps[targetedIndex] };
          let newInfluencedInf = { ...ps[influencedIndex] };
          if (type === "decrease") {
            newTargetedInf.order--;
            newInfluencedInf.order++;
          } else if (type === "increase") {
            newTargetedInf.order++;
            newInfluencedInf.order--;
          }
          newTableInfos[targetedIndex] = newTargetedInf;
          newTableInfos[influencedIndex] = newInfluencedInf;

          return newTableInfos;
        });
      }
    }
  };
  const handleDrag = (ev) => {
    if (actionStatus !== "editing" && actionStatus !== "adding") setDragId(ev.currentTarget.id);
  };

  const handleDrop = (ev) => {
    if (actionStatus !== "editing" && actionStatus !== "adding") {
      setTableInfos((ps) => {
        let newTableInfos = [...ps];
        let dragBoxIndex = newTableInfos.findIndex((inf) => {
          return inf?.id === dragId;
        });
        let dropBoxIndex = newTableInfos.findIndex((inf) => {
          return inf?.id === ev?.currentTarget?.id;
        });
        let newDragBox = { ...ps[dragBoxIndex] };
        let newDropBox = { ...ps[dropBoxIndex] };
        let newDragBoxOrder = newDropBox.order;
        let newDropBoxOrder = newDragBox.order;
        newDragBox.order = newDragBoxOrder;
        newDropBox.order = newDropBoxOrder;
        newTableInfos[dragBoxIndex] = newDragBox;
        newTableInfos[dropBoxIndex] = newDropBox;

        return newTableInfos;
      });
    }
  };

  return (
    <>
      {tableInfos
        .sort((a, b) => a.order - b.order)
        .map((data, index) => (
          <span
            className={classes.columnEditLine}
            key={index}
            id={data.id}
            draggable={true}
            onDragOver={(ev) => ev.preventDefault()}
            onDragStart={handleDrag}
            onDrop={handleDrop}
            onClick={(e) => changeShownColumnHandler(data.id, undefined)}
          >
            <span className={classes.actionsContainer}>
              <input
                className={classes.columnEditLineCheckBox}
                type="checkbox"
                id={data.id}
                checked={data.show}
                onChange={(e) => changeShownColumnHandler(e.target.id, e.target.checked)}
              />
              <span className={classes.upAndDownArrowContainer}>
                <DownArrow
                  onClick={(e) => changeOrderHandler(e, data, "decrease")}
                  className={[
                    classes.upArrow,
                    data.order === 1 ? classes.disabledColor : classes.enabledColor,
                  ].join(" ")}
                />
                <DownArrow
                  onClick={(e) => changeOrderHandler(e, data, "increase")}
                  className={[
                    classes.downArrow,
                    data.order === tableInfos.length ? classes.disabledColor : classes.enabledColor,
                  ].join(" ")}
                />
              </span>
            </span>
            <label className={classes.checkboxEditColumns} htmlFor={data.id}>
              {data.label || <MultiLanTxt tid={data.labelTid} />}
            </label>
          </span>
        ))}
    </>
  );
};

export default ColumnsPersonalizer;
